export const globe = () => (
  <path
    d="M7.018 17.39L17.976 4.46M12 19v3m0 0H8.5m3.5 0h3.5m2.017-17.966A8.5 8.5 0 116.483 16.966 8.5 8.5 0 0117.517 4.034zm.892 11.96a12.455 12.455 0 00-4.295-8.002A12.454 12.454 0 005.59 5.007a12.455 12.455 0 004.295 8.002 12.455 12.455 0 008.523 2.984z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
